module.exports = __webpack_public_path__ + "84ef5235f0069f48faa5347d83bad5b2.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/stomach/stomach-5.png
// module id = 3092
// module chunks = 0